import React from "react";
import Typography from "@mui/material/Typography";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import Box from "@mui/material/Box";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import AssignmentReturnIcon from "@mui/icons-material/AssignmentReturn";
import "./SuccessMessage.css";

const linkStyle = {
  textDecoration: "none",
  color: "#4CAF50",
  display: "flex",
  alignItems: "center",
  margin: "8px",
  fontSize: "1rem",
  transition: "color 0.3s",
};

const SuccessMessage = () => {
  return (
    <Box
      className="success-message"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="93.7vh"
    >
      <CheckCircleOutlineIcon
        sx={{ fontSize: 100, color: "#4CAF50", marginBottom: 2 }}
        aria-label="Success Icon"
      />
      {/* <Typography variant="h4" gutterBottom >
        Autocitirea ta a fost transmisa cu succes!
      </Typography> */}
      <Typography variant="body1" gutterBottom sx={{ color: "#4CAF50" }}>
        Datele au fost preluate si vor parcurge etapele de validare
      </Typography>

      <a
        href="https://www.distributie-energie.ro/"
        target="_blank"
        rel="noopener noreferrer"
        style={{ ...linkStyle, color: "#4CAF50" }}
      >
        <Typography variant="body1" sx={{ color: "#4CAF50" }}>
          Inapoi la pagina principala
        </Typography>
        <OpenInNewIcon sx={{ ml: 1 }} />
      </a>

      {/* <a href="/Autocitiri" style={linkStyle}>
        <Typography variant="body1" sx={{ color: "#4CAF50" }}>
          Transmite inca o autocitire
        </Typography>
        <AssignmentReturnIcon sx={{ ml: 1 }} />
      </a> */}
    </Box>
  );
};

export default SuccessMessage;
